import { ReactElement, ReactNode } from 'react';
import useModalLifecycle from './useModalLifecycle';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';

export interface ICenterModalProps {
    title: string;
    subtitle?: string;
    dataTarget: string;
    body: ReactNode;
    footer?: ReactElement;
    onClick?: () => void;
    onHide?: () => void;
    className?: string;
    dataDismiss?: string;
    dataTestId?: string;
    showDividers?: boolean;
}

function CenterModal(props: ICenterModalProps) {
    const {
        title,
        subtitle,
        dataTarget,
        body,
        footer,
        onClick,
        onHide,
        className = 'w-[850px] max-w-[90vw]',
        dataDismiss = 'modal',
        dataTestId,
        showDividers = true,
    } = props;

    useModalLifecycle(dataTarget, onHide);

    return (
        <div
            className="nj-modal p-0"
            id={dataTarget}
            aria-labelledby="ModalLabel"
            data-backdrop="static"
        >
            <div
                className={`nj-modal__dialog p-0 my-[50px] mx-auto ${className}`}
                role="document"
            >
                <div
                    className="nj-modal__content p-0 flex flex-col overflow-hidden max-h-[90vh]"
                    data-testid={dataTestId}
                >
                    <ModalHeader
                        title={title}
                        subtitle={subtitle}
                        onClick={onClick}
                        dataDismiss={dataDismiss}
                        showDivider={showDividers}
                    />
                    <ModalBody content={body} />
                    {footer && (
                        <ModalFooter
                            content={footer}
                            showDivider={showDividers}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default CenterModal;
